import { useState, type FC } from "react";

import { Input } from "@/shared/components/ui/input";
import { Label } from "@/shared/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/shared/components/ui/select";
import { PROFESSIONAL_ROLE_OPTIONS } from "@/shared/constants/contactDetailOptions";

import type { PersonContact } from "@/shared/types/estateContact";
import { EditSectionShell } from "./EditSectionShell";

interface ProfessionalDetailsEditProps {
  contact: PersonContact;
  onCancel: () => void;
  onSave: (updates: Record<string, unknown>) => Promise<void>;
  isSaving: boolean;
}

export const ProfessionalDetailsEdit: FC<ProfessionalDetailsEditProps> = ({
  contact,
  onCancel,
  onSave,
  isSaving,
}) => {
  const [role, setRole] = useState(contact.professional_role || "");
  const [company, setCompany] = useState(contact.company_or_firm || "");

  const handleSave = () => {
    onSave({
      professional_role: role || null,
      company_or_firm: company.trim() || null,
    });
  };

  return (
    <EditSectionShell
      title="Professional details"
      onCancel={onCancel}
      onSave={handleSave}
      isSaving={isSaving}
    >
      <div className="flex flex-col gap-1.5">
        <Label>Professional role</Label>
        <Select value={role} onValueChange={setRole}>
          <SelectTrigger className="w-full font-normal">
            <SelectValue placeholder="Select role" />
          </SelectTrigger>
          <SelectContent>
            {PROFESSIONAL_ROLE_OPTIONS.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <div className="flex flex-col gap-1.5">
        <Label>Company or firm</Label>
        <Input
          value={company}
          onChange={(e) => setCompany(e.target.value)}
          placeholder="Company or firm name"
        />
      </div>
    </EditSectionShell>
  );
};
